import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BrutalPage from "../pages/brutal/page";
import AboutPage from "../pages/about/page";
import ServicesPage from "../pages/services/page";
import PricingPage from "../pages/pricing/page";
import PortfolioPage from "../pages/portfolio/page";
import WorkPage from "../pages/work/page";
import GalleryPage from "../pages/gallery/page";
import CasesPage from "../pages/cases/page";
import ContactPage from "../pages/contact/page";
import SmsOptIn from "../pages/sms-optin/page";
import PayPage from "../pages/pay/page";
import PaySuccessPage from "../pages/pay/success";
import TemplatePreviewPage from "../pages/preview/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <BrutalPage />,
  },
  {
    path: "/palmer",
    element: <Home />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/services",
    element: <ServicesPage />,
  },
  {
    path: "/pricing",
    element: <PricingPage />,
  },
  {
    path: "/work",
    element: <WorkPage />,
  },
  {
    path: "/gallery",
    element: <GalleryPage />,
  },
  {
    path: "/cases",
    element: <CasesPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/sms-optin",
    element: <SmsOptIn />,
  },
  {
    path: "/pay",
    element: <PayPage />,
  },
  {
    path: "/pay/success",
    element: <PaySuccessPage />,
  },
  {
    path: "/preview/:templateId",
    element: <TemplatePreviewPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
